import React from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

// Fixed order so an item keeps its color as long as the item order does.
const COLORS = ["#6d28d9", "#0891b2", "#d97706", "#be185d", "#15803d", "#475569"];

export const formatHour = (hour) => {
  const h = ((hour % 24) + 24) % 24;
  if (h === 0) return "12 AM";
  if (h === 12) return "12 PM";
  return h < 12 ? `${h} AM` : `${h - 12} PM`;
};

// Stacked forecast per hour of the business day, one series per prep item.
// Leading and trailing hours with no forecast are trimmed.
export default function PrepHourlyChart({ items }) {
  const series = items.filter(item => item.hourly?.length);
  if (!series.length) return null;
  const byHour = new Map();
  series.forEach(item => item.hourly.forEach(({ hour, total }) => {
    const row = byHour.get(hour) || { hour, label: formatHour(hour) };
    row[item.uuid] = Math.round(total * 10) / 10;
    byHour.set(hour, row);
  }));
  const rows = [...byHour.values()].sort((a, b) => a.hour - b.hour);
  // Only same-unit items add up; different units sit side by side instead.
  const stacked = new Set(series.map(item => item.unit_label)).size === 1;
  const hasValue = row => series.some(item => row[item.uuid] > 0);
  const first = rows.findIndex(hasValue);
  const last = rows.length - 1 - [...rows].reverse().findIndex(hasValue);
  if (first === -1) return <p className="py-8 text-center text-sm text-slate-500">No hourly forecast for this day yet.</p>;

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={rows.slice(first, last + 1)} margin={{ top: 8, right: 8, left: -12, bottom: 0 }}>
        <CartesianGrid vertical={false} stroke="#eef0f3" />
        <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#64748b" }} tickLine={false} axisLine={{ stroke: "#e2e8f0" }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 12, fill: "#64748b" }} tickLine={false} axisLine={false} />
        <Tooltip cursor={{ fill: "#f5f3ff" }} />
        {series.length > 1 && <Legend wrapperStyle={{ fontSize: 12 }} />}
        {series.map((item, index) => (
          <Bar key={item.uuid} dataKey={item.uuid} name={item.name} stackId={stacked ? "prep" : undefined}
            fill={COLORS[index % COLORS.length]} radius={!stacked || index === series.length - 1 ? [4, 4, 0, 0] : 0} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
